import React, { Fragment } from "react";
import axios from "axios";
import SimpleModalWrapped from "./../common/Modal";
import { ReactComponent as SendIcon } from "../../assets/nav/send.svg";
import TextField from "./../common/TextField";
import { withStyles } from "@mui/styles";
import Tooltip from "./../common/Tooltip";
import MenuItem from "./../common/MenuItem";
import Grid from "@mui/material/Grid";
import { categoriesList, checkPrivileges } from "../../Helpers";
import SingleSelect from "../common/SingleSelect";
import { unitsList } from "./unitsPortList";
import { timeZonesTypes } from "./../Attributes/timezone";
import Button from "../common/Button";
import { Avatar, Paper, Tabs, Tab } from "@mui/material";
import { Scrollbar } from "react-scrollbars-custom";
import withTranslationWrapper from "../../HOC/withTranslation";
import CustomDatePicker from "../common/CustomDatePicker";

const styles = (theme) => ({});

const fuelTypes = [
  { value: 1, label: "Gasoline" },
  { value: 2, label: "Diesel" },
  { value: 3, label: "Ethanol" },
  { value: 4, label: "Hybrid" },
  { value: 5, label: "Electric" },
  { value: 6, label: "Biodiesel" },
  { value: 7, label: "CNG" },
  { value: 8, label: "LPG" },
  { value: 9, label: "Hydrogen" },
];
const lifecycleStatuses = ["Active", "In Maintenance", "Suspended", "Retired"];
const transmissionTypes = [
  "Manual",
  "Automatic",
  "Semi-Automatic",
  "CVT",
  "Other",
];

//let emptyLink = "javascript:void(0)";
class addDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: {
        name: this.props.selectedDevice.category || "default",
        id: this.props.selectedDevice.category || "default",
      },
      images: [],
      applied: false,

      visible: true,
      at_modal_visable: false,
      isVisableDeviceBtn: false,
      form: {
        attributes: {},
      },
      open: true,
      isAdvSettingEnable: false,
      activeTab: 0,
    };
    this.addAttributes = this.addAttributes.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.searchFromList = this.searchFromList.bind(this);
    this.searchFromZoneList = this.searchFromZoneList.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleChangeTab = this.handleChangeTab.bind(this);

    // this.checkRequiredFields=this.checkRequiredFields.bind(this)
    // this.formSubmit=this.formSubmit.bind(this)
  }

  onChange(category) {
    this.setState({ category });
    this.props.logo_handelChanges(category);
  }

  handleChangeTab(event, activeTab) {
    this.setState({ activeTab });
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }

  toggleCollapse() {
    let a = this.state.open;
    this.setState({
      open: !a,
    });
  }

  addAttributes() {
    this.setState({
      at_modal_visable: !this.state.at_modal_visable,
    });
  }

  async searchFromList(inputValue) {
    if (!inputValue) {
      return [];
    }

    return await axios({
      method: "GET",
      url: `/api/devices/models?search=${inputValue}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.data && response.data.data && response.data.data.data) {
        return response.data.data.data.map((item) => {
          return {
            id: item.name,
            name: item.name,
            key: item.name,
            port: item.port,
            protocol: item.protocol,
            label: item.name,
            value: item.name,
          };
        });
      }
    });
  }

  async searchFromZoneList(inputValue) {
    if (!inputValue) {
      return [];
    }

    const result = timeZonesTypes.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    return await result.map((item) => {
      return {
        id: item.key,
        key: item.key,
        label: item.label,
        value: item.key,
      };
    });
  }

  render() {
    const { classes, formSection } = this.props;
    const { images } = this.props;
    const showInnerTabs = !formSection;
    const showBasic = formSection
      ? formSection === "basic"
      : this.state.activeTab === 0;
    const showSpecifications = formSection
      ? formSection === "specifications"
      : this.state.activeTab === 1;

    const defaultOptions = [];
    unitsList.map((item, i) => {
      if (i <= 9) {
        defaultOptions.push({
          id: item.device,
          name: item.device,
          key: item.device,
          port: item.port,
          protocol: item.protocol,
          label: item.device,
          value: item.device,
        });
      }
      return null;
    });
    if (
      defaultOptions &&
      defaultOptions.length < unitsList.length &&
      unitsList
    ) {
      defaultOptions.push({
        id: "",
        name: "Search for more items...",
        key: "",
        port: "",
        label: "Search for more items...",
        value: "",
        isDisabled: true,
      });
    }
    const defaultZones = [];
    timeZonesTypes.map((item, i) => {
      // if (i <= 9) {
      defaultZones.push({
        id: item.key,
        key: item.key,
        label: item.label,
        value: item.key,
      });
      //}
      return null;
    });

    /* defaultZones.push({
      id: '',
      name: 'Search for more items...',
      key: '',
      port: '',
      label: 'Search for more items...',
      value: '',
      isDisabled: true
    }) */
    return (
      <Fragment>
        <SimpleModalWrapped
          visable
          isButtonVisable
          title=""
          formSubmit={this.props.formSubmit}
          notShowAttributesBtn
          notShowGroupBtn={this.props.notShowGroupBtn}
          modalControle={this.props.modalControle}
          buttonText={this.props.buttonText}
          isVisableBtn={this.props.isVisableDeviceBtn}
          btnCancelNotShow={this.props.btnCancelNotShow}
          canUpdate={checkPrivileges(this.props.isHaveAccess)}
          hasPremissions
          HaveGroupCreateAccess={checkPrivileges("groupCreate")}
          elevation={this.props.editOption !== undefined ? 0 : 2}
          showPortList={this.props.showPortList}
          showPort={this.props.showPort}
          btnCloseText={"close"}
          content={
            <form autoComplete="off">
              {showInnerTabs && (
                <Tabs
                  value={this.state.activeTab}
                  onChange={this.handleChangeTab}
                  variant="scrollable"
                  scrollButtons="auto"
                  TabIndicatorProps={{ style: { display: "none" } }}
                  className="custom-tabs"
                  style={{ marginBottom: 8 }}
                >
                  <Tab
                    classes={{
                      root: "common-tab",
                      selected: "tab-selected",
                      wrapper: "tab-wrapper",
                    }}
                    label={
                      this.props.translate("basic") || "Basic"
                    }
                  />
                  <Tab
                    classes={{
                      root: "common-tab",
                      selected: "tab-selected",
                      wrapper: "tab-wrapper",
                    }}
                    label="Specifications"
                  />
                </Tabs>
              )}

              {showBasic && (
                <>
              <div style={{ marginTop: 5 }}>
                <h4
                  className="all-attributes-heading"
                  style={{ margin: "5px 0", fontSize: 16 }}
                >
                  Vehicle Details
                </h4>
                <Grid container>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <TextField
                      id="name"
                      label={this.props.translate("sharedName")}
                      type="text"
                      placeholder=""
                      required
                      value={this.props.form.name || ""}
                      onChange={this.props.handleChange("name")}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <TextField
                      id="vehicleLicensePlate"
                      label={
                        this.props.translate("vehicleLicensePlate") ||
                        "License Plate"
                      }
                      required
                      value={this.props.form.vehicleLicensePlate || ""}
                      onChange={this.props.handleChange("vehicleLicensePlate")}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <TextField
                      id="vin"
                      label="VIN / Chassis"
                      value={this.props.form.vin || ""}
                      onChange={this.props.handleChange("vin")}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <TextField
                      id="vehicleMake"
                      label={this.props.translate("make") || "Make"}
                      value={this.props.form.vehicleMake || ""}
                      onChange={this.props.handleChange("vehicleMake")}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <TextField
                      id="vehicleModel"
                      label="Vehicle Model"
                      value={this.props.form.vehicleModel || ""}
                      onChange={this.props.handleChange("vehicleModel")}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <TextField
                      id="vehicleYear"
                      label="Year"
                      type="number"
                      value={this.props.form.vehicleYear || ""}
                      onChange={this.props.handleChange("vehicleYear")}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </div>

              <div style={{ marginTop: 5 }}>
                <h4
                  className="all-attributes-heading"
                  style={{ margin: "5px 0", fontSize: 16 }}
                >
                  Tracker Details
                </h4>
                <Grid container>
                  {this.props.editOption ? (
                    checkPrivileges("deviceModel") ? (
                      <Grid
                        item
                        xl={6}
                        md={6}
                        xs={6}
                        style={{ zIndex: 99, padding: "0 8px" }}
                      >
                        <SingleSelect
                          array={[]}
                          async
                          selectName="model"
                          isClearable
                          defaultOptions={defaultOptions}
                          loadOptions={this.searchFromList}
                          label={this.props.translate("deviceModel") + "*"}
                          value={
                            typeof this.props.form.model === "object"
                              ? this.props.form.model
                              : this.props.form.model
                              ? {
                                  id: this.props.form.model,
                                  key: this.props.form.model,
                                  label: this.props.form.model,
                                  value: this.props.form.model,
                                }
                              : ""
                          }
                          handleChange={this.props.port_handleChange}
                          canAssign
                        />
                      </Grid>
                    ) : null
                  ) : (
                    <Grid
                      item
                      xl={6}
                      md={6}
                      xs={6}
                      style={{ zIndex: 99, padding: "0 8px" }}
                    >
                      <SingleSelect
                        array={[]}
                        async
                        selectName="model"
                        isClearable
                        defaultOptions={defaultOptions}
                        loadOptions={this.searchFromList}
                        label={this.props.translate("deviceModel") + "*"}
                        value={
                          typeof this.props.form.model === "object"
                            ? this.props.form.model
                            : this.props.form.model
                            ? {
                                id: this.props.form.model,
                                key: this.props.form.model,
                                label: this.props.form.model,
                                value: this.props.form.model,
                              }
                            : ""
                        }
                        handleChange={this.props.port_handleChange}
                        canAssign
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xl={6}
                    md={6}
                    xs={6}
                    style={{ padding: "0 8px" }}
                  >
                    {this.props.form.model !== "FX Tracker" ? (
                      <TextField
                        id="uniqueId"
                        label={this.props.translate("deviceIdentifier")}
                        type="text"
                        placeholder=""
                        required
                        value={this.props.form.uniqueId || ""}
                        InputProps={
                          this.props.editOption
                            ? { readOnly: !checkPrivileges("deviceImei") }
                            : ""
                        }
                        onChange={this.props.handleChange("uniqueId")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                    ) : (
                      <Tooltip title={this.props.translate("autoGeneratedId")}>
                        <TextField
                          id="uniqueId"
                          label={this.props.translate("deviceIdentifier")}
                          type="text"
                          placeholder=""
                          required
                          value={this.props.form.uniqueId || ""}
                          variant="outlined"
                          margin="dense"
                          disabled={
                            this.props.editOption ||
                            (this.props.logInUser &&
                              this.props.logInUser.userType !== -1)
                          }
                          fullWidth
                        />
                      </Tooltip>
                    )}
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <CustomDatePicker
                      format="dd/MM/yyyy"
                      error={false}
                      label={
                        this.props.translate("installDate") || "Install Date"
                      }
                      fullWidth
                      value={
                        this.props.form.attributes?.installDate || null
                      }
                      onChange={(date) =>
                        this.props.handleChangeLicenseExpDate(
                          "installDate",
                          date
                        )
                      }
                    />
                  </Grid>
                  <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                    <CustomDatePicker
                      format="dd/MM/yyyy"
                      error={false}
                      label={
                        this.props.translate("expireDate") || "Expire Date"
                      }
                      fullWidth
                      value={this.props.form.expirationTime || null}
                      onChange={(date) =>
                        this.props.handleChangeLicenseExpDate(
                          "expirationTime",
                          date
                        )
                      }
                    />
                  </Grid>
                  {this.props.addOption && (
                    <Grid item md={12} xs={12} style={{ padding: "0 8px" }}>
                      <p
                        style={{
                          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                          fontSize: "16",
                          background: this.props.themecolors.backgroundColor,
                          color: this.props.themecolors.textColor,
                          padding: "12px 33px",
                          marginTop: 0,
                          marginLeft: "25",
                        }}
                      >
                        <span>
                          {this.props.translate(
                            "toConfigureYourDeviceManuallyUseConnectionParameters"
                          )}
                        </span>
                        <span style={{ display: "block" }}>
                          <label
                            style={{ width: "40%", display: "inline-block" }}
                          >
                            {this.props.translate("serverIP")}:
                          </label>
                          <span>{this.props.serverIp}</span>
                        </span>
                        <span style={{ display: "block" }}>
                          <label
                            style={{ width: "40%", display: "inline-block" }}
                          >
                            {this.props.translate("Port")}:
                          </label>
                          <span>{this.props.form.device}</span>
                        </span>
                      </p>
                    </Grid>
                  )}
                </Grid>
              </div>

              <h4
                className="all-attributes-heading"
                style={{ margin: "5px 0", fontSize: 16 }}
              >
                {this.props.translate("driver")}
              </h4>
              <Grid container>
                <Grid item xl={6} md={6} xs={12} style={{ padding: "0 8px" }}>
                  <TextField
                    id="driverName"
                    label={this.props.translate("driverName")}
                    placeholder=""
                    value={
                      this.props.form.attributes &&
                      this.props.form.attributes.driverName
                        ? this.props.form.attributes.driverName
                        : ""
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 60) {
                        this.props.changeAttribute2("driverName", e);
                      }
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={12} style={{ padding: "0 8px" }}>
                  <TextField
                    id="driverPhoneNumber"
                    label={this.props.translate("driverPhoneNumber")}
                    placeholder=""
                    value={
                      (this.props.form.attributes &&
                        this.props.form.attributes.driverPhoneNumber) ||
                      ""
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 15) {
                        this.props.changeAttribute2("driverPhoneNumber", e);
                      }
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={12} style={{ padding: "0 8px" }}>
                  <TextField
                    id="code"
                    label={this.props.translate("driverCode")}
                    placeholder=""
                    value={
                      (this.props.form.attributes &&
                        this.props.form.attributes.code) ||
                      ""
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 15) {
                        this.props.changeAttribute2("code", e);
                      }
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                  {this.state.codeError && <p>{this.state.codeError}</p>}
                </Grid>
              </Grid>

              <h4
                className="all-attributes-heading"
                style={{ margin: "5px 0", fontSize: 16 }}
              >
                {this.props.translate("icons")}
              </h4>
              <div style={{ padding: "0 5px" }}>
                <Grid container spacing={1} style={{ padding: "0 8px" }}>
                  <Scrollbar style={{ height: 110 }}>
                    <ul className="units-category-list">
                      {images.map((item, i) => {
                        return (
                          <>
                            <Grid
                              style={{ cursor: "pointer", margin: "2px" }}
                              item
                              key={i}
                              onClick={(e) => this.onChange(item)}
                            >
                              <Tooltip title={this.props.translate(item.name)}>
                                <Paper
                                  style={{
                                    textAlign: "center",
                                    alignItems: "center",
                                  }}
                                  className={
                                    item.name ===
                                    (this.state.category.name || "default")
                                      ? "unit-image-active"
                                      : "unit-image"
                                  }
                                >
                                  <Avatar
                                    alt=""
                                    src={
                                      "/assets/category/default/" +
                                      item.name +
                                      ".svg"
                                    }
                                    style={{
                                      margin: "2px",
                                      height: 55,
                                      width: 55,
                                    }}
                                  />
                                </Paper>
                              </Tooltip>
                            </Grid>
                          </>
                        );
                      })}
                    </ul>
                  </Scrollbar>
                </Grid>
              </div>
                </>
              )}

              {showSpecifications && (
                <>
              <h4
                className="all-attributes-heading"
                style={{ margin: "5px 0 5px", fontSize: 16 }}
              >
                Vehicle Specifications
              </h4>
              <Grid container>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="operationalHours"
                    label="Operational Hours"
                    type="number"
                    inputProps={{ min: 1, max: 24 }}
                    value={this.props.form.operationalHours || ""}
                    onChange={this.props.handleChange("operationalHours")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="registrationNumber"
                    label="Registration Number"
                    value={this.props.form.registrationNumber || ""}
                    onChange={this.props.handleChange("registrationNumber")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="lifecycleStatus"
                    select
                    label="Lifecycle Status"
                    value={this.props.form.lifecycleStatus || ""}
                    onChange={this.props.handleChange("lifecycleStatus")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {lifecycleStatuses.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="fuelType"
                    select
                    label="Fuel Type"
                    value={this.props.form.fuelType || ""}
                    onChange={this.props.handleChange("fuelType")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {fuelTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {[
                  ["fuelEfficiency", "Average Fuel Efficiency", "number"],
                  ["totalAvailablekm", "Standard Daily Mileage", "number"],
                  ["capacity", "Tank Capacity", "number"],
                  ["color", "Color", "text"],
                  ["chassisNumber", "Chassis Number", "text"],
                  ["variant", "Variant", "text"],
                  ["wheels", "Wheels", "number"],
                  ["country", "Country", "text"],
                ].map(([name, label, type]) => (
                  <Grid
                    item
                    xl={6}
                    md={6}
                    xs={6}
                    style={{ padding: "0 8px" }}
                    key={name}
                  >
                    <TextField
                      id={name}
                      label={label}
                      type={type}
                      value={this.props.form[name] || ""}
                      onChange={this.props.handleChange(name)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                ))}
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="transmissionType"
                    select
                    label="Transmission Type"
                    value={this.props.form.transmissionType || ""}
                    onChange={this.props.handleChange("transmissionType")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {transmissionTypes.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>

              <h4
                className="all-attributes-heading"
                style={{ margin: "10px 0 5px", fontSize: 16 }}
              >
                Tracker Specifications
              </h4>
              <Grid container>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="phone"
                    label={this.props.translate("simNumber")}
                    type="text"
                    placeholder=""
                    value={this.props.form.phone || ""}
                    onChange={this.props.handleChange("phone")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="onlineTime"
                    label={`${this.props.translate("onlineTime")} ${"  "}${this.props.translate("min")}`}
                    type="number"
                    placeholder=""
                    value={this.props.form?.attributes?.onlineTime || ""}
                    onChange={(e) =>
                      this.props.changeAttribute2("onlineTime", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="contact"
                    label={this.props.translate("deviceContact")}
                    placeholder=""
                    value={this.props.form.contact || ""}
                    onChange={this.props.handleChange("contact")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="category"
                    select
                    label={this.props.translate("deviceCategory")}
                    value={this.props.form.category || ""}
                    onChange={this.props.handleChange("category")}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value={0}>
                      <em>None</em>
                    </MenuItem>
                    {categoriesList.map((option) => (
                      <MenuItem key={option} value={option}>
                        {this.props.translate(option)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="attributeDevicePassword"
                    label={this.props.translate("attributeDevicePassword")}
                    placeholder=""
                    value={
                      (this.props.form.attributes &&
                        this.props.form.attributes.devicePassword) ||
                      ""
                    }
                    onChange={(e) =>
                      this.props.changeAttribute2("devicePassword", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                {[1, 2, 3, 4, 5].map((index) => (
                  <Grid
                    item
                    xl={6}
                    md={6}
                    xs={6}
                    style={{ padding: "0 8px" }}
                    key={`tag_${index}`}
                  >
                    <TextField
                      id={`tag_${index}`}
                      label={`Tag ${index}`}
                      value={
                        this.props.form.attributes?.[`tag_${index}`] || ""
                      }
                      onChange={(e) =>
                        this.props.changeAttribute2(`tag_${index}`, e)
                      }
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                ))}
                <Grid
                  item
                  xl={6}
                  md={6}
                  xs={6}
                  style={{ padding: "0 8px", zIndex: 9 }}
                >
                  <SingleSelect
                    array={[]}
                    async
                    selectName="decoder.timezone"
                    isClearable={false}
                    defaultOptions={defaultZones}
                    loadOptions={this.searchFromZoneList}
                    label={this.props.translate("sharedTimezone")}
                    value={
                      this.props.form.attributes &&
                      this.props.form.attributes["decoder.timezone"]
                        ? timeZonesTypes.find(
                            (t) =>
                              t.key ===
                              this.props.form.attributes["decoder.timezone"]
                          ) || {
                            key: this.props.form.attributes["decoder.timezone"],
                            id: this.props.form.attributes["decoder.timezone"],
                            label:
                              this.props.form.attributes["decoder.timezone"],
                            value:
                              this.props.form.attributes["decoder.timezone"],
                          }
                        : ""
                    }
                    handleChange={this.props.timezone_handleChange}
                    canAssign
                  />
                </Grid>
                <Grid item xl={6} md={6} xs={6} style={{ padding: "0 8px" }}>
                  <TextField
                    id="attributeSpeedLimit"
                    label={
                      this.props.translate("attributeSpeedLimit") + " (Km/h)"
                    }
                    type="number"
                    inputProps={{ min: 0 }}
                    placeholder=""
                    value={
                      (this.props.form.attributes &&
                        this.props.form.attributes.speedLimit) ||
                      ""
                    }
                    onChange={(e) =>
                      this.props.changeAttribute2("speedLimit", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
              </Grid>
                </>
              )}
            </form>
          }
        />
      </Fragment>
    );
  }
}

const AddDevice = withStyles(styles);
export default AddDevice(withTranslationWrapper(addDevice));
